import { AnyAction } from 'redux';

export const gesamtpreisHiddenReducer = function (
  sectionState: boolean = null,
  action: AnyAction,
): boolean {
  switch (action.type) {
    default:
      return sectionState;
  }
};
